<template>
    <b-overlay :show="loading" rounded="sm">
        <li class="nav-item dropdown mr-2">
            <a id="navbarDropdownOrganization" class="nav-link d-flex align-items-center font-600 leading-6" href="#" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                <span v-if="actual_group">
                    {{ actual_group.name | truncate(20) }}
                </span>

                <span v-else>
                    ---
                </span>

                <svg width="20" height="20" class="ml-1 text-muted" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
                    <path fill-rule="evenodd" d="M5.23 7.21a.75.75 0 011.06.02L10 11.168l3.71-3.938a.75.75 0 111.08 1.04l-4.25 4.5a.75.75 0 01-1.08 0l-4.25-4.5a.75.75 0 01.02-1.06z" clip-rule="evenodd"></path>
                </svg>
            </a>

            <div class="dropdown-menu dropdown-menu-right" aria-labelledby="navbarDropdownOrganization">

                <a class="dropdown-item" href="javascript:;" v-for="group in groups" :key="group.id" :class="{'active': group.id === actualGroupId }" @click="changeGroup(group.id)">
                    <span class="badge badge-secondary text-light" v-b-tooltip.hover title="Código da Turma">{{ group.code }}</span> {{ group.name | truncate(25) }}
                </a>

                <div class="dropdown-divider" v-if="groups.length !== 0"></div>

                <a class="dropdown-item" :href="endpointEnterGroup">
                    <i class="fas fa-sign-in-alt mr-1"></i> Ingressar com Código
                </a>

            </div>
        </li>
    </b-overlay>
</template>

<script>
export default {
    props: [
        'endpointGroups',
        'endpointChangeGroup',
        'endpointEnterGroup'
    ],
    data() {
        return {
            loading: false,
            groups: [],
            actual_group: null
        }
    },
    computed: {

        actualGroupId() {
            if (this.actual_group !== null) {
                return this.actual_group.id
            }

            return false;
        }

    },
    created() {

        this.loadGroups()

    },
    methods: {

        loadGroups() {
            this.loading = true;
            axios.get(this.endpointGroups)
                .then((result) => {
                    const response = result.data.data

                    this.groups = response.groups
                    this.actual_group = response.actual_group
                })
                .finally(() => this.loading = false)
        },

        changeGroup(group_id) {
            this.loading = true;
            axios.put(this.endpointChangeGroup, {
                group_id: group_id
            })
                .then((result) => {
                    // Redirect
                    this.redirectIfNeed(result)
                })
                .finally(() => this.loading = false)
        }
    }
}
</script>

<style scoped>

</style>
